import { useEffect } from 'react';
import { ScrollOptions } from '../../Scroll';
import { UseScrollTo } from './useScrollTo.types';

/**
 * Scrolls to the referenced DOM element when scroll is `true`
 *
 * @param scrollable - {@link UseScrollTo scrollable} description.
 * @param options - {@link UseScrollTo options} description.
 * @param scroll - {@link UseScrollTo scroll} description.
 */
const useScrollTo: UseScrollTo = ({
    scrollable,
    scroll,
    options,
}) => {
    useEffect(() => {
        if (scrollable.current && scroll) {
            scrollable.current.scrollIntoView({ ...options,
                ...ScrollOptions });

            if (scrollable.current.focus) {
                scrollable.current.focus();
            }
        }
    }, [scrollable, options, scroll]);
};

export default useScrollTo;